import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import useDebounce from "../../hooks/useDebounce";
// import { validateSafeInput } from "../../utils/utils";

const Search = ({ data, setFiltered, setTotal, value, handleSearch }) => {
  const [searchText, setSearchText] = useState(value ?? "");
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    if (value !== undefined && value !== searchText) setSearchText(value);
  }, [value]);

  const debouncedSearchText = useDebounce(searchText);

  useEffect(() => {
    if (!isChanged && !debouncedSearchText) return;

    if (handleSearch) handleSearch(debouncedSearchText);
    else handleDefaultSearch();
  }, [debouncedSearchText]);

  const handleDefaultSearch = () => {
    const search = searchText?.toLowerCase();

    const result = data?.filter((item) => {
      const name = item?.user?.name || item?.name || "";
      const email = item?.user?.email || item?.email || "";
      const mobile = item?.mobile_no || "";
      const fileNo = item?.file_number?.toString() || "";

      return (
        (name && name.toLowerCase().includes(search)) ||
        (email && email.toLowerCase().includes(search)) ||
        (mobile && mobile.toLowerCase().includes(search)) ||
        (fileNo && fileNo.toLowerCase().includes(search))
      );
    });

    setFiltered(result);
    if (setTotal) setTotal(result?.length);
  };

  const sanitizeValue = (val) => String(val || "").replace(/[<>${}]/g, "");

  const onChange = (e) => {
    const value = e.target.value;
    const clean = sanitizeValue(value);
    setSearchText(clean);
    if (!isChanged) setIsChanged(true);
  };

  const onKeyDown = (e) => {
    if (["<", ">", "{", "}", "$"].includes(e.key)) {
      e.preventDefault();
    }
  };

  // const onPaste = (e) => {
  //   const text = (e.clipboardData || window.clipboardData)?.getData("text");
  //   if (!validateSafeInput(text)) {
  //     e.preventDefault();
  //     const clean = sanitizeValue(text);
  //     setSearchText(clean);
  //     if (!isChanged) setIsChanged(true);
  //   }
  // };

  return (
    <div>
      <Input
        placeholder="Search"
        value={searchText}
        onChange={onChange}
        onKeyDown={onKeyDown}
        // onPaste={onPaste}
        suffix={<SearchOutlined style={{ color: "gray" }} />}
      />
    </div>
  );
};

export default Search;
